import axios from 'axios';
// import has from 'lodash';

import router from '@/router';
import store from '@/store';

function refreshToken () {
  return new Promise((resolve, reject) => {
    store.dispatch('session/refresh').then(() => {
      resolve();
    }, error => {
      redirectToLogin();

      if (!(error instanceof Error)) {
        error = new Error();
      }
      error.fatal = true;

      return reject(error);
    });
  });
}

function redirectToLogin () {
  const query = {};
  // if (has(router, 'history.current') != null) {
  //   query.redirectFrom = router.history.current.fullPath;
  // }
  store.dispatch('reset');
  router.push({ name: 'login', query });
}

let refreshPromise = null;

export default {
  requestHandler: config => {
    return config;
  },

  responseHandler: response => {
    return response;
  },

  errorHandler: error => {
    if (!error.config) {
      return Promise.reject(error);
    } else {
      if (error.config.url.indexOf('security') !== -1) {
        return Promise.reject(error);
      } else {
        if (error.response && error.response.status === 401) {
          if (!refreshPromise) {
            refreshPromise = refreshToken().finally(() => {
              refreshPromise = null;
            });
          }

          return refreshPromise.then(() => axios.request(error.config));
        } else {
          return Promise.reject(error);
        }
      }
    }
  }
};
